import type JCE from '@chesscom/js-chess-engine';

/**
 * Check if a game is in a win state according to JCE (checkmate or variant win like 3-Check)
 **/
export function isJCEWin(game: JCE.Game): boolean {
  return game.inCheckmate() || Boolean(game.isVariantWin()) || Boolean(game.isBughouseWin());
}
